<template>
    <div class="price-tag-renderer" :style="themeStyle">
        <component
            :is="layoutComponent"
            :values="values"
            :fields-by-key="fieldsByKey"
            :errors="errors"
            :editable="editable"
            :context="context"
            @update-value="payload => emit('update-value', payload)"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { get } from 'lodash';
import { resolvePriceTagLayout } from '@/js/utils/price-tags/price-tag-presets';
import { getPriceTagThemeStyle } from '@/js/utils/price-tags/price-tag-context';

const props = defineProps({
    layout: {
        type: String,
        default: null,
    },
    values: {
        type: Object,
        default: () => ({}),
    },
    fieldsByKey: {
        type: Object,
        default: () => ({}),
    },
    errors: {
        type: Object,
        default: () => ({}),
    },
    editable: {
        type: Boolean,
        default: false,
    },
    context: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['update-value']);

const store = useStore();

const layoutComponent = computed(() => resolvePriceTagLayout(props.layout));

const themeStyle = computed(() =>
    getPriceTagThemeStyle(get(store, 'state.clientConfig.generalConfig.priceTags.theme'))
);
</script>

<style lang="scss" scoped>
.price-tag-renderer {
    display: inline-block;
}
</style>
